








































export default {
	name: 'cantidad',
	props: {
		name: {
			type: String,
		},
		valor: {
			type: Number,
		},
		producto: {
			type: Object,
		},
		idcarrito: {
			type: Number,
		},
		method: {
			type: Function,
		},
		view: {
			type: String,
			default: 'pedido',
		},
	},

	data() {
		return {
			value: 2,
			cantidad: null,
			loading: false,
		};
	},
	filters: {
		singular: function (name: string): String {
			return name.substring(name.length, name.length - 2) === 'es' ? name.substring(0, name.length - 2) : name.substring(0, name.length - 1);
		},
	},
	methods: {
		handleCommand(command: string): void {
			if (command === '9999') return;
			this.value = parseInt(command);
			this.$refs.dropcantidad.hide();
			if (this.producto) {
				this.producto['pedido_id'] = this.idcarrito;
				this.producto['pedido_cantidad'] = command;
				this.updateCantidad(this.producto);
			}
		},
		aplicar(value = true): void {
			if (value) {
				this.value = parseInt(this.cantidad);
				this.$refs.dropcantidad.blur();
			}
			if (this.producto) {
				this.producto['pedido_id'] = this.idcarrito;
				this.producto['pedido_cantidad'] = this.value;
				this.updateCantidad(this.producto);
			}
		},
		updateCantidad(producto: Object): void {
			this.loading = true;
			if (this.view === 'ocompra') {
				this.$store.dispatch('putCantidadOrden', producto).then(() => {
					this.loading = false;
				});
			} else {
				this.$store.dispatch('putCantidad', producto).then(() => {
					this.loading = false;
				});
			}
		},
	},
	watch: {
		value(v) {
			this.method(v);
		},
		valor(v) {
			this.value = v;
		},
	},
	created() {
		this.value = this.valor;
	},
};
